@let isLoading = loadingService.isLoading$(this) | async;

<icz-new-storage-unit-specification-form
  [waiting]="isLoading"
  class="block p-16"
  [form]="form"
></icz-new-storage-unit-specification-form>

<icz-form-buttons>
  <ng-container leftButtons>
    <icz-button iczFormSubmit
                [disabled]="isLoading"
                (onAction)="submit(false)"
                primary label="Založit"
    ></icz-button>
    <icz-button iczFormSubmit
                [disabled]="isLoading"
                label="Založit a přejít k nastavení oprávnění"
                (onAction)="submit(true)"
    ></icz-button>
  </ng-container>
  <icz-button rightButtons
              [disabled]="isLoading"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
